export const vendorsConstants = {
  GET_VENDORS: 'GET_VENDORS',
};
